import { render, staticRenderFns } from "./productCostEng.vue?vue&type=template&id=643f52e2&scoped=true"
import script from "./productCostEng.vue?vue&type=script&lang=js"
export * from "./productCostEng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643f52e2",
  null
  
)

export default component.exports